import { Box, Collapse, Flex, Text } from '@chakra-ui/react'
import { coverageWillChangeDetailsFields, coverageWillChangeOptions } from '@hb/shared'
import { useCallback, useState } from 'react'
import { useField } from 'react-final-form'
import { useForm } from '../../../FinalForm/FormProvider'
import { useFormWizard } from '../../../FormWizard/context'
import { FormElement } from '../../../Input'
import { useInsuranceInfoStage } from '../InsuranceInfoStageContext'
import { OptionSelectButtons, SelectedOptionView } from './OptionSelectButton'

// const ConfirmPartnerIndividualNote = () => (
//   <FormElement name="confirmPartnerIndividual" field={confirmPartnerIndividualNote} />
// )

// const AssessmentOnPartnerPlanNote = () => (
//   <FormElement name="planToAssess" field={assessmentOnPartnerPlanNote} />
// )

// const AssessmentOnCurrentPlanNote = () => (
//   <FormElement name="assessmentOnCurrentPlan" field={assessmentOnCurrentPlanNote} />
// )
const MultipleCoverageOptionsComplete = ({ loadingOption }: { loadingOption: string | null }) => {
  const {
    input: { value: option, onChange: onChangeOption },
  } = useField('coverageWillChangeDescription', { subscription: { value: true } })

  // const {
  //   input: { value: confirmPartnerPlan },
  // } = useField('confirmPartnerPlan', { subscription: { value: true } })
  // const {
  //   input: { value: planToAssess },
  // } = useField('planToAssess', { subscription: { value: true } })

  // const {
  //   input: { value: multipleOptionsOtherNotes },
  // } = useField('multipleOptionsOtherNotes', { subscription: { value: true } })

  // const subText = useMemo(() => {
  //   switch (option) {
  //     case 'partner-individual':
  //       return confirmPartnerPlan
  //         ? 'I have confirmed that I am covered by this plan'
  //         : 'Since you are not covered by this plan, please choose another option for the first question'
  //     case 'partner-employer':
  //       if (!planToAssess) return ''
  //       return planToAssess === 'current-plan'
  //         ? 'I want an assessment on my current plan'
  //         : 'I want an assessment on my partner/ family member’s plan'
  //     case 'other':
  //       return multipleOptionsOtherNotes
  //     default:
  //       return ''
  //   }
  // }, [option, confirmPartnerPlan, planToAssess, multipleOptionsOtherNotes])

  return (
    <>
      <Flex gap={1.5} width="100%">
        <SelectedOptionView
          onEditClick={() => onChangeOption(null)}
          selected={option}
          options={coverageWillChangeOptions}
          loading={!!loadingOption}
          // subText={subText}
        />
      </Flex>
      {/* <ConfirmPartnerIndividualNote /> */}
      {/* <AssessmentOnCurrentPlanNote /> */}
      {/* <AssessmentOnPartnerPlanNote /> */}
    </>
  )
}

export const CoverageWillChange = () => {
  const { readOnly } = useFormWizard()
  const { insuranceInfoData } = useInsuranceInfoStage()
  const { option = null } = insuranceInfoData ?? {}
  const {
    input: { value: coverageWillChangeDescription },
  } = useField('coverageWillChangeDescription', { subscription: { value: true } })

  const { change, saveWithoutValidation } = useForm()
  const [loadingOption, setLoadingOption] = useState<string | null>(null)

  const onChange = useCallback(
    async (updated: string | null) => {
      change('coverageWillChangeDescription', updated)
      if (!updated) return
      setLoadingOption(updated ?? null)
      await saveWithoutValidation(false)
      setLoadingOption(null)
    },
    [change, saveWithoutValidation],
  )

  return (
    <Collapse in={option === 'coverage-will-change'}>
      <Box w="100%" pt={2}>
        {!readOnly && (
          <Collapse in={!coverageWillChangeDescription}>
            <Flex w="100%" flexFlow="column" gap={2}>
              <Text px={1} fontWeight={600} lineHeight={1} fontSize="lg" color="gray.600">
                Please specify:
              </Text>
              <OptionSelectButtons
                options={coverageWillChangeOptions}
                onSelectOption={onChange}
                loadingOption={loadingOption}
              />
            </Flex>
          </Collapse>
        )}
        <Collapse in={!!coverageWillChangeDescription}>
          <MultipleCoverageOptionsComplete loadingOption={loadingOption} />
        </Collapse>
        <Box pt={2} pointerEvents={readOnly ? 'none' : 'auto'}>
          {Object.entries(coverageWillChangeDetailsFields).map(([key, field]) => (
            <FormElement key={key} name={key} field={field} readOnly={readOnly} />
          ))}
        </Box>
      </Box>
    </Collapse>
  )
}
